import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAllAnonymized = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.551189 0.31441L0 0.861717L0.881126 1.74284C0.473557 2.35614 0.236778 3.08976 0.236778 3.88161C0.236778 6.02426 1.97574 7.76322 4.11839 7.76322C4.91024 7.76322 5.64386 7.52644 6.25716 7.11887L7.13828 8L7.68559 7.45269L0.551189 0.31441ZM4.11839 6.9869C2.4066 6.9869 1.0131 5.5934 1.0131 3.88161C1.0131 3.30713 1.17225 2.77147 1.44784 2.30568L5.69432 6.55216C5.22853 6.82775 4.69287 6.9869 4.11839 6.9869ZM2.54245 1.21106L1.97962 0.644347C2.59292 0.236778 3.32654 0 4.11839 0C6.26104 0 8 1.73896 8 3.88161C8 4.67346 7.76322 5.40708 7.35565 6.02038L6.78894 5.45366C7.06453 4.99175 7.22368 4.45609 7.22368 3.88161C7.22368 2.16982 5.83018 0.776322 4.11839 0.776322C3.54391 0.776322 3.00825 0.935468 2.54245 1.21106Z",
		fill: "#4F4F4F"
	})
});
export default SvgAllAnonymized;
